let location = document.querySelector('.location-tabs');
let locationItem = document.querySelector('.location-tabs');
